function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-2-2h24v24H-2z"
}), React.createElement("path", {
  d: "M13.511 14.559a8.235 8.235 0 111.048-1.048c.031.023.06.048.089.076l4.706 4.706a.75.75 0 01-1.06 1.06l-4.707-4.705a.756.756 0 01-.076-.089zm-5.276.412a6.735 6.735 0 100-13.471 6.735 6.735 0 000 13.47z",
  fill: "#2A2C2D"
}));

var SvgIconMagnifyingGlass = function SvgIconMagnifyingGlass(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    focusable: false
  }, props), React.createElement("title", null, title), _ref2);
};

export default __webpack_public_path__ + "static/media/icon-magnifying-glass.b503cca0.svg";
export { SvgIconMagnifyingGlass as ReactComponent };